import { inject, Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StructureField } from '../interfaces/incidents-reporter-survey.response';
import { IncidentsReporterSurveyForm } from './incidents-reporter-survey-form';

@Injectable({
  providedIn: 'root'
})
export class IncidentsReporterSurveyFormFactory {
  // Service injections
  private _fb = inject(FormBuilder);
  private _incidentsReporterSurveyForm = inject(IncidentsReporterSurveyForm);
  
  // Methods
  createForm(structureFields: StructureField[]): FormGroup {
    const group: { [key: string]: any } = {};

    structureFields.forEach((field, index) => {
      const validators = [];
      if (field.required) {
        validators.push(Validators.required);
      }
      if (field.type === 'email') {
        validators.push(Validators.email);
        validators.push(Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/));
      }

      const key = `${field.type}_${index}`;
      group[key] = this._fb.control(null, validators);
    });
    return this._fb.group(group);
  }
  
  resetForm(form: FormGroup): void {
    // Reset form state without emitting events
    form.reset({}, { emitEvent: false, onlySelf: false });
    Object.keys(form.controls).forEach(key => {
      form.get(key)?.markAsPristine();
      form.get(key)?.markAsUntouched();
      form.get(key)?.updateValueAndValidity();
    });
    
    this._incidentsReporterSurveyForm.setMarkAllFormFieldsAsTouched(false);
  }
}
